import loadable from '@loadable/component'

export const KeyFigure = loadable(() => import('./KeyFigure'))
export const KeyFigures = loadable(() => import('./KeyFigures'))
export type { KeyFigureProps } from './KeyFigure'
export type { KeyFiguresProps } from './KeyFigures'
